import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[trimInput]',
    standalone: true,
})
export class TrimInputDirective {
    constructor(private el: ElementRef<HTMLInputElement>) {}

    @HostListener('blur')
    onBlur() {
        const input = this.el.nativeElement;
        input.value = input.value.trim();
        input.dispatchEvent(new Event('input'));
    }
}
